export default class BuyerSearch
{	
	constructor()
	{
		this.phone = null;
		this.email = null;
		this.username = null;
		this.textSearchField = null;
		this.nif = null;
		this.comprador = null;
		this.idEmpresa = null;
		this.listaCompradores = null;
		this.callback = null;
		this.newAccreditation = false;
	}

    sanitizeSearchText(text)
    {
        if (!text || text.trim() === "")
        {
            return "";
        }
        let sanitized = text.replace(/['"\\]/g, ' ');
        sanitized = sanitized.replace(/\s+/g, ' ')
            .replace(/\s+([*!":])/g,'*')
            .replace(/\*+/g, '* ')
            .replace(/\:+/g, '')
            .trim();
        return sanitized;
    }
	
	resetFormBuyerSearch(isAdvancedSeach = false)
	{
		if(!isAdvancedSeach)
		{
			document.getElementById("fulltext-search-buyer").classList.remove("large-3", "medium-6", "small-12");
			document.getElementById("fulltext-search-buyer").classList.add("large-10");
			document.getElementById("advanced-search-buyer").style.display = "none";
			document.getElementById("advanced_search_clickable").innerHTML = polyglot.t("global.Advanced_search");
		}

		document.getElementById("fullText").value = "";
		document.getElementById("emailBusq").value = "";
		document.getElementById("telefonoBusq").value = "";
		document.getElementById("nifBusq").value = "";

		$("#tablaCompradores tbody").html("<tr><td colspan='6'>" + polyglot.t("No_buyers_found") + "</td></tr>");
		
		if($('#formBusquedaComprador') != undefined && $('#formBusquedaComprador').length != 0)
		{
			$('#formBusquedaComprador')[0].reset();
		}
		
	}
	
	showFormBuyerSearch(callback)
	{
		this.callback = callback;
		this.resetFormBuyerSearch();
		showModal("#vBusquedaComprador", 'largeSize');
	}
	
	searchBuyer()
	{
		if(document.getElementById("advanced-search-buyer").style.display == "block")
		{
			this.email = $("#emailBusq").val();
			this.telefono = $("#telefonoBusq").val();
			this.nif = $("#nifBusq").val();
		}
		else
		{
			this.email = "";
			this.telefono = "";
			this.nif = "";
		}

		let string = $("#fullText").val();
		
		this.textSearchField = this.sanitizeSearchText(string);
		
		if (this.email == "")
			this.email = null;

		if (this.telefono == "")
			this.telefono = null;

		if (this.nif == "")
			this.nif = null;

		if (this.textSearchField == "")
			this.textSearchField = null;
			
		if (typeof idEmpresa !== "undefined" && idEmpresa != null) this.idEmpresa = idEmpresa;
		else if (typeof filtroActual !== "undefined" && filtroActual != null && filtroActual.idEmpresa != null) this.idEmpresa = filtroActual.idEmpresa;
		else if (typeof idEmpresaUsuario !== "undefined" && idEmpresaUsuario != null) this.idEmpresa = idEmpresaUsuario;
		
		if (mode_visualization && mode_visualization == CRM_VISUALIZATION_MODE.ACCREDITATIONS)
		{
			this.idRecinto = filtroActual.idRecinto;
			this.idEvento = filtroActual.idEvento;
			if (this.newAccreditation)
			{
				this.idRecinto = null;
				this.idEvento = null;
			}
		}
		
		if (this.idEmpresa == null)
		{
			alertaKO(polyglot.t("filter.err_company"));
			hideModal("#vBusquedaComprador");
			return;
		}
		
		if (this.validate()) {
			alertaKO(polyglot.t("Please_provide_any_field_to_search_the_buyer"));
		}
		else {
			this.listaCompradores = [];
			crearVentanaEspera(null);
			BackofficeAjax.buscarComprador(null, this.idEmpresa, this.idRecinto, this.idEvento, this.email, this.telefono, this.nif, this.textSearchField, this.resultadoBusquedaComprador);
		}
	}
	
	resultadoBusquedaComprador(datosCompradores)
	{
		let component = window.buyerSearch;
		if (datosCompradores == null || datosCompradores.length == 0) {
			if ((component.email != null || component.telefono != null || component.nif != null) && component.textSearchField != null) {
				BackofficeAjax.buscarComprador(null, component.idEmpresa, component.idRecinto, component.idEvento, null, null, null, component.textSearchField, component.resultadoBusquedaComprador);
			}
			else {
				$("#tablaCompradores tbody").html("<tr><td colspan='6'>" + polyglot.t("No_buyers_found") + "</td></tr>");
				loadNotification([polyglot.t("No_results_found")], "error", 5000);
			}
		}
		else {
			for(let i = 0; i < datosCompradores.length; i++)
			{
				let comp = datosCompradores[i];
				if(comp.nombre)
				{
					comp.nombre = DOMPurify.sanitize(datosCompradores[i].nombre);
				}
				if(comp.apellidos)
				{
					comp.apellidos = DOMPurify.sanitize(datosCompradores[i].apellidos);
				}
			}

			component.listaCompradores = datosCompradores.filter((tag, index, array) => array.findIndex(t => t.idComprador == tag.idComprador) == index);

			var htmlTabla = "";
			for (let i in component.listaCompradores) {
				let comp = component.listaCompradores[i];
				let email = comp.email;
				if (email == null || email == "") {
					email = "-";
				}

				let buyerEmail = (comp.oauthProvider == 'facebook') ? "<img width='13' height='13' class='mr0_3' src='img/logos/facebook.svg'>" + email : email;

				htmlTabla += "<tr><td>" + comp.nombre
					+ "</td><td>" + comp.apellidos
					+ "</td><td>" + (comp.nif != null ? comp.nif : "&nbsp;")
					+ "</td><td>" + (comp.telefono != null ? comp.telefono : "&nbsp;")
					+ "</td><td>" + buyerEmail
					+ "</td><td class='btn-action-big'>" + "<button class='button tiny secondary expanded dynamic-tooltip' onclick='buyerSearch.selCompradorResultadoBusqueda(" + i + ");' class='dynamic-tooltip' title='" + polyglot.t("global.Select") + "'>" + polyglot.t("global.Select") + "</button>"
					+ "</td></tr>";
			}

			$("#tablaCompradores tbody").html(htmlTabla);
			refrescarTooltip();
		}

		$("#tablaCompradores").show();
		var elmnt = document.getElementById("tablaCompradores");
		elmnt.scrollIntoView();

		cambiarVentanaEsperaOK(false);
	}
	
	validate()
	{
		if (this.email == null && this.telefono == null && this.nif == null && this.textSearchField == null)
		{
			return true;
		}
	}
	
	selCompradorResultadoBusqueda(i)
	{
		hideModal('#vBusquedaComprador');
		this.comprador = this.listaCompradores[i];
		if (this.callback != null && typeof this.callback === "function") {
			this.callback(this.comprador);
		}
	}
	
	showAdvancedSearch()
	{
		if (document.getElementById("advanced-search-buyer").style.display == 'none')
		{
			document.getElementById("fulltext-search-buyer").classList.remove("large-10");
			document.getElementById("fulltext-search-buyer").classList.add("large-3", "medium-6", "small-12");
			document.getElementById("advanced-search-buyer").style.display = "block";
			document.getElementById("advanced_search_clickable").innerHTML = polyglot.t("global.Normal_search");
		}
		else
		{
			document.getElementById("fulltext-search-buyer").classList.add("large-10");
			document.getElementById("fulltext-search-buyer").classList.remove("large-3", "medium-6", "small-12");
			document.getElementById("advanced-search-buyer").style.display = "none";
			document.getElementById("advanced_search_clickable").innerHTML = polyglot.t("global.Advanced_search");
		}
	}
	
	removeFooter()
	{
		if(document.querySelector('#vBusquedaComprador .footer-modal') != null) document.querySelector('#vBusquedaComprador .footer-modal').remove();
	}

}
